import { CssBaseline } from "@material-ui/core";
import RxFooter from "../components/RxFooter";
import RxTopBar from "../components/RxTopBar";
import styles from "./Layout.module.css";

const Layout = (props: any) => {
	return (
		<div className={styles.rootElement}>
			<CssBaseline />
			<RxTopBar />
			<main className={styles.contentElement}>{props.children}</main>
			<footer className={styles.footerElement}>
				<RxFooter />
			</footer>
		</div>
	);
};

export default Layout;
